import { render, staticRenderFns } from "./SplitterModalTED.vue?vue&type=template&id=acae3ab4&scoped=true"
import script from "./SplitterModalTED.vue?vue&type=script&lang=js"
export * from "./SplitterModalTED.vue?vue&type=script&lang=js"
import style0 from "./SplitterModalTED.vue?vue&type=style&index=0&id=acae3ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acae3ab4",
  null
  
)

export default component.exports